var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { HelixStyles } from '../../helix';
import { Tooltip } from '../Tooltip';
/**
 * Component to display tooltip when hover if text truncated.
 */
export const OverflowTooltip = (props) => {
    const { title, dataId, style } = props, rest = __rest(props, ["title", "dataId", "style"]);
    const dataIdPrefix = `${dataId}-overflow-tooltip`;
    //ref
    const ref = useRef(null);
    //state
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
    //effect
    useEffect(() => {
        var _a;
        const checkEllipsis = () => {
            if (ref.current) {
                setIsEllipsisActive(ref.current.offsetWidth < ref.current.scrollWidth);
            }
        };
        checkEllipsis();
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseover', checkEllipsis);
        return () => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseover', checkEllipsis);
        };
    }, []);
    const propsTruncated = Object.assign(Object.assign({}, rest), HelixStyles.truncate);
    const finalTitle = isEllipsisActive ? title : '';
    return (_jsx(Tooltip, Object.assign({ title: finalTitle }, { children: _jsx(Typography, Object.assign({ "data-title": finalTitle, "data-id": dataIdPrefix }, propsTruncated, { whiteSpace: "nowrap", ref: ref, style: Object.assign({}, style) })) })));
};
export default OverflowTooltip;
